var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcUsersIllustration = function SvgIcUsersIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9E1F8",
    d: "M60.5 101.5c22.644 0 41-18.356 41-41s-18.356-41-41-41-41 18.356-41 41 18.356 41 41 41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#63B9E9",
    d: "M73.055 45.008c0 6.94-5.628 14.435-12.568 14.435-6.94 0-12.569-7.495-12.569-14.435s5.628-11.87 12.569-11.87c6.945 0 12.568 4.925 12.568 11.87ZM44.881 86.171H75.57a7.428 7.428 0 0 0 7.075-5.165l1.65-5.16c1.21-3.782-.758-7.872-4.481-9.232-12.487-4.567-25.403-3.979-38.632.42-3.704 1.234-5.763 5.199-4.74 8.966l1.272 4.688a7.42 7.42 0 0 0 7.167 5.483Z"
  })));
};
export default SvgIcUsersIllustration;